import {
  ArrowDownRight, ArrowRight, ArrowUpRight, AlertCircle, AlertTriangle, Bell, BellOff,
  Bug, Building2, CalendarDays, Check, CheckCircle2, ChevronDown, ChevronLeft, ChevronRight,
  CircleDollarSign, CircleDot, ClipboardCheck, Clock, Copy, Database, Download, ExternalLink, Eye, Filter,
  FileText, GitBranch, GitPullRequest, Globe, GripVertical, Hammer, HeartPulse, HelpCircle,
  Inbox, Layers, Lightbulb, Link as LinkIcon, ListChecks, Lock, LogOut,
  Mail, MessageSquare, MessagesSquare, Moon, MoreHorizontal, MoreVertical, Network,
  Paperclip, PauseCircle, Pencil, Percent, Play, Plus, RefreshCw, Rocket, RotateCcw, ScrollText, Search, Send,
  Settings, ShieldAlert, ShieldCheck, Smile, Sparkles, StickyNote, Sun, Trash2, TrendingUp, User, Video, X, Zap,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

/**
 * Cockpit Icon — Lucide strokes (1.75 at small sizes), addressed by the
 * design system's kebab-case glyph names.
 */
const GLYPHS: Record<string, LucideIcon> = {
  'arrow-down-right': ArrowDownRight,
  'arrow-right': ArrowRight,
  'arrow-up-right': ArrowUpRight,
  'bell': Bell,
  'bell-off': BellOff,
  'bug': Bug,
  'building-2': Building2,
  'calendar-days': CalendarDays,
  'check': Check,
  'check-circle-2': CheckCircle2,
  'chevron-down': ChevronDown,
  'chevron-left': ChevronLeft,
  'chevron-right': ChevronRight,
  'circle-alert': AlertCircle,
  'circle-dollar-sign': CircleDollarSign,
  'circle-dot': CircleDot,
  'clipboard-check': ClipboardCheck,
  'clock': Clock,
  'copy': Copy,
  'database': Database,
  'download': Download,
  'ellipsis': MoreHorizontal,
  'ellipsis-vertical': MoreVertical,
  'external-link': ExternalLink,
  'eye': Eye,
  'file-text': FileText,
  'funnel': Filter,
  'git-branch': GitBranch,
  'git-pull-request': GitPullRequest,
  'globe': Globe,
  'grip-vertical': GripVertical,
  'hammer': Hammer,
  'heart-pulse': HeartPulse,
  'help-circle': HelpCircle,
  'inbox': Inbox,
  'layers': Layers,
  'lightbulb': Lightbulb,
  'link': LinkIcon,
  'list-checks': ListChecks,
  'lock': Lock,
  'log-out': LogOut,
  'mail': Mail,
  'message-square': MessageSquare,
  'messages-square': MessagesSquare,
  'moon': Moon,
  'network': Network,
  'paperclip': Paperclip,
  'pause-circle': PauseCircle,
  'pencil': Pencil,
  'percent': Percent,
  'play': Play,
  'plus': Plus,
  'refresh-cw': RefreshCw,
  'rocket': Rocket,
  'rotate-ccw': RotateCcw,
  'scroll-text': ScrollText,
  'search': Search,
  'send': Send,
  'settings': Settings,
  'shield-alert': ShieldAlert,
  'shield-check': ShieldCheck,
  'smile': Smile,
  'sparkles': Sparkles,
  'sticky-note': StickyNote,
  'sun': Sun,
  'trash-2': Trash2,
  'trending-up': TrendingUp,
  'triangle-alert': AlertTriangle,
  'user': User,
  'video': Video,
  'x': X,
  'zap': Zap,
};

export interface IconProps {
  name: string;
  size?: number;
  strokeWidth?: number;
  className?: string;
  style?: React.CSSProperties;
}

export default function Icon({ name, size = 16, strokeWidth = 1.75, className = '', style }: IconProps) {
  const Glyph = GLYPHS[name];
  if (!Glyph) {
    console.warn(`Icon: unknown glyph "${name}"`);
    return null;
  }
  return <Glyph size={size} strokeWidth={strokeWidth} className={className} style={style} aria-hidden="true" />;
}
